import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { RebillingService } from '../../../../services/rebilling.service';
import { CreateProductRequest } from '../../../../models/requests/create-product-request';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDividerModule } from '@angular/material/divider';
import { NgIf } from '@angular/common';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-create-custom-plan-dialog',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatDividerModule,
    NgIf
  ],
  templateUrl: './create-custom-product-dialog.component.html',
  styleUrl: './create-custom-product-dialog.component.scss'
})
export class CreateCustomPlanDialogComponent {
  isLoading = false;
  isRebillingSetup = false;
  paymentPlanForm!: FormGroup;
  
  constructor(
    public dialogRef: MatDialogRef<CreateCustomPlanDialogComponent>,
    private rebillingService: RebillingService,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { rebillingInfoId: number }) { }

  ngOnInit() {
    this.initFormGroup();
  }

  initFormGroup() {
    this.paymentPlanForm = this.formBuilder.group({
      productName: [undefined, [Validators.required]],
      productDescription: [undefined, [Validators.required]],
      monthlyPricing: [undefined, [Validators.required]],
      overageCharge: [undefined, [Validators.required,Validators.min(0.1)]],
      overageLimit: [undefined, [Validators.required]]
    });
  }

  onProductCreated() {
    if (this.paymentPlanForm.valid) {
      this.isLoading = true;
      const request: CreateProductRequest = {
        productName: this.paymentPlanForm.value["productName"],
        productDescription: this.paymentPlanForm.value["productDescription"],
        monthlyPricing: this.paymentPlanForm.value["monthlyPricing"],
        overageCharge: this.paymentPlanForm.value["overageCharge"],
        overageLimit: this.paymentPlanForm.value["overageLimit"],
        rebillingInfoId: this.data.rebillingInfoId
      }

      this.rebillingService.createProduct(request).subscribe({
        next: () => {
          this.isLoading = false;
          this.dialogRef.close()
        },
        error: () => {
          this.isLoading = false;
          alert('Error from server contact support');
        }
      })
    }
  }
}
